<template>
	<div>
		<div class="h4">{{ $t('Database connection & query') }}</div>
		<tooltip label="Type your sql query" placement="right">
			<codemirror
				ref="codemirror"
				:placeholder="$t('Type your sql query')"
				:options="cmOptions"
				v-model="commandResponse.resp_data_source_query_string"
			></codemirror>
		</tooltip>
		<div class="h4">{{ $t('Response Info') }}</div>
		<tooltip label="Data Limit" placement="right">
			<input
				name="text"
				v-model.lazy="commandResponse.resp_data_source_resp_data_limit"
				class="form-control"
				type="text"
			/>
		</tooltip>
		<tooltip label="Response Via" placement="right">
			<select class="form-control" v-model="commandResponse.resp_data_source_resp_via">
				<option value="text">{{ $t('Text') }}</option>
				<option value="card">{{ $t('Card URL or List') }}</option>
				<option value="quick_rep">{{ $t('Quick Replies') }}</option>
				<option value="video">{{ $t('Video') }}</option>
				<option value="Image">{{ $t('Image') }}</option>
			</select>
		</tooltip>
		<tooltip label="Text" placement="right" v-show="commandResponse.resp_data_source_resp_via == 'text'">
			<input
				class="form-control"
				v-autocomplete="autocomplete"
				v-model="commandResponse.resp_data_source_resp_struct.title_key"
				:placeholder="$t('Text')"
			/>
		</tooltip>
		<div v-if="commandResponse.resp_data_source_resp_via == 'quick_rep'">
			<CommandResponseQuickReply
				:autoCompleteModules="autocomplete"
				:records="commandResponse.resp_quick_reply"
				:private_services="private_services"
				:public_services="public_services"
				:command_id_to_name="command_id_to_name"
				@passQuickReplies="onQuickReplySave"
			>
			</CommandResponseQuickReply>
		</div>
		<tooltip
			v-hide
			label="Default Text"
			placement="right"
			v-show="commandResponse.resp_data_source_resp_via == 'text'"
		>
			<input
				class="form-control"
				v-autocomplete="autocomplete"
				v-model="commandResponse.resp_data_source_resp_struct.title_default_value"
				:placeholder="$t('Default Text')"
			/>
		</tooltip>
		<ComamandResponseCard
			v-show="commandResponse.resp_data_source_resp_via === 'card'"
			:buttons="commandResponse.resp_data_source_resp_struct.buttons"
			:title="commandResponse.resp_data_source_resp_struct.title_key || commandResponse.resp_data_source_resp_struct.title_default_value"
			:subTitle="commandResponse.resp_data_source_resp_struct.subtitle_key || commandResponse.resp_data_source_resp_struct.subtitle_default_value"
			:autoCompleteModules="autocomplete"
			@onNewButtonClick="push_button(commandResponse.resp_data_source_resp_struct.buttons)"
			@onRemoveButtonClick="(pos) => remove_button(pos, commandResponse.resp_data_source_resp_struct.buttons)"
		>
			<template slot="title">
				<tooltip label="value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="commandResponse.resp_data_source_resp_struct.title_key"
						:placeholder="$t('value')"
					/>
				</tooltip>
				<tooltip label="default value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="commandResponse.resp_data_source_resp_struct.title_default_value"
						:placeholder="$t('default value')"
					/>
				</tooltip>
			</template>

			<template slot="subTitle">
				<tooltip label="value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="commandResponse.resp_data_source_resp_struct.subtitle_key"
						:placeholder="$t('value')"
					/>
				</tooltip>
				<tooltip label="default value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="commandResponse.resp_data_source_resp_struct.subtitle_default_value"
						:placeholder="$t('default value')"
					/>
				</tooltip>
			</template>

			<template slot="media">
				<tooltip label="value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="commandResponse.resp_data_source_resp_struct.media_key"
						:placeholder="$t('value')"
					/>
				</tooltip>
				<tooltip label="default value" placement="right">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="commandResponse.resp_data_source_resp_struct.media_default_value"
						:placeholder="$t('default value')"
					/>
				</tooltip>
			</template>

			<template
				:slot="'button.' + ii"
				v-for="(button, ii) in  commandResponse.resp_data_source_resp_struct.buttons"
			>
				<tooltip label="button label" placement="right" :key="'button.label.' + ii">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="button.item_label_key"
						:placeholder="$t('button label')"
					/>
				</tooltip>

				<tooltip label="button value" placement="right" :key="'button.value.' + ii">
					<input
						class="form-control"
						v-autocomplete="autocomplete"
						v-model="button.item_value_key"
						:placeholder="$t('button value')"
					/>
				</tooltip>
			</template>
		</ComamandResponseCard>
	</div>
</template>

<script>
import ComamandResponseCard from '@/components/ComamandResponseCard'
import CommandResponseQuickReply from '@/components/CommandResponseQuickReply'
import {codemirror} from 'vue-codemirror'
import axios from 'axios'

export default {
	components: {
		codemirror,
		ComamandResponseCard,
		CommandResponseQuickReply
	},
	props: {
		commandResponse: {
			type: Object,
		},
	},
	data() {
		return {
			autocomplete: {},
			cmOptions: {
				mode: 'text/x-mariadb',
				...this.$store.state.cm_base_options,
			},
			private_services: [],
			public_services: [],
			command_id_to_name: {},
		}
	},
	methods: {
		push_button(btns_arr) {
			btns_arr.push({
				item_label_key: '',
				item_label_default_value: '',
				item_value_key: '',
				item_value_default_value: '',
			})
		},

		remove_button(pos, btns_arr) {
			btns_arr.splice(pos, 1)
		},

		get_services_commands(){
			axios.get('/service/get_list').then(({data}) => {
				if (data.status) {
					this.private_services = data.private;
					this.public_services = data.public;
					// assign command_id => name
					for(let i in this.private_services){
						for(let k in this.private_services[i].commands){
							this.command_id_to_name[ this.private_services[i].commands[k]['command_id'] ] = this.private_services[i].commands[k]['command_name'];
						}
					}

					for(let i in this.public_services){
						for(let k in this.public_services[i].commands){
							this.command_id_to_name[ this.public_services[i].commands[k]['command_id'] ] = this.public_services[i].commands[k]['command_name'];
						}
					}
				}
			})
		},

		onQuickReplySave(data){
			if(Array.isArray(data)){
				this.commandResponse['resp_quick_reply'] = data;
			} else {
				this.commandResponse['resp_quick_reply'] = [];
			}
			return true;
		}
	},
	created() {
		this.get_services_commands();
		// this.commandResponse.resp_data_source_resp_struct = {
		// 	title_key: '',
		// 	title_default_value: '',
		// 	subtitle_key: '',
		// 	subtitle_default_value: '',
		// 	media_key: '',
		// 	media_default_value: '',
		// 	item_label_key: '',
		// 	item_label_default_value: '',
		// 	item_value_key: '',
		// 	item_value_default_value: '',
		// 	buttons: [
		// 		{
		// 			item_label_key: '',
		// 			item_label_default_value: '',
		// 			item_value_key: '',
		// 			item_value_default_value: '',
		// 		},
		// 	],
		// };
	},
}
</script>

<style lang="scss" scoped>
</style>
